import { useContext } from "react";
import { ScrollContext } from "../../context/Scroll";

export const useScrollContext = () => {
    const context = useContext(ScrollContext);
    if (!context) {
        throw Error("useScrollContext without provider");
    }
    return context;
}